import '../css/Spinner.css';

const Spinner = () =>(
    <div className='containerSpinner'>
        <div className='spinner'> </div>
        <h6>CARGANDO...</h6>
    </div>
)

export default Spinner;